module.exports = __webpack_public_path__ + "media/images/donation/how-to-use6-c0dc75f78aac6aef1c3d69273213d953.jpg";